import {
  currentTenantRole,
  SystemUserPermissions,
  userCurrentTenant,
} from 'api/endpoints/users';
import {
  ReadingCacheType,
  useReadAPIWithServices,
} from 'api/useAPIWithServices';
import { PERMISSION } from 'components/organisms/form/manageUser/config';
import { TENANT_ROLE, UserRole } from 'constants/roles';
import { useAppServices } from 'container/depContext';

function getUserPermissions(isUser: boolean) {
  return Object.keys(PERMISSION).reduce(
    (acc, next) => ({
      ...acc,
      [next]: !isUser,
    }),
    {}
  );
}

export const useUserInfo = () => {
  const { getUserRepo } = useAppServices();
  const { getCurrentUserInfo } = getUserRepo();

  const { data: currentUserInfo, isLoading: isCurrentUserInfoLoading } =
    useReadAPIWithServices(
      [getCurrentUserInfo.name],
      () => getCurrentUserInfo(),
      {
        cacheType: ReadingCacheType.Static,
      }
    );

  const isUserAdmin = currentUserInfo?.role === UserRole.Admin;

  const tenantRole = currentUserInfo
    ? currentTenantRole(currentUserInfo)
    : undefined;

  const isUserTenantAdmin = tenantRole === TENANT_ROLE.ADMIN;

  const isUserTenantUser = !tenantRole || tenantRole === TENANT_ROLE.USER;

  const tenantRoles = Object.fromEntries(
    (currentUserInfo?.tenants || []).map((t) => [t.tenant.id, t.userRole])
  );

  const userPermissionsForCurrentTenant = (
    !isUserAdmin && isUserTenantUser && currentUserInfo
      ? userCurrentTenant(currentUserInfo)?.permissions ||
        getUserPermissions(true)
      : getUserPermissions(false)
  ) as SystemUserPermissions;

  return {
    currentUserInfo,
    isCurrentUserInfoLoading,
    isUserAdmin,
    isUserTenantAdmin,
    tenantRole,
    isUserTenantUser,
    tenantRoles,
    userPermissionsForCurrentTenant,
  };
};
